import { combineReducers } from "redux";
import { menuReducers } from "./slices/menuSlice";
import { userReducers } from "./slices/userSlice";

export const rootReducer = combineReducers({
    user: userReducers,
    menu: menuReducers,
});

export function* rootSaga() {}
